import { z } from 'zod';

// Display preferences; null = Auto (browser default). The preset → Intl options
// mapping is display logic and lives in the web app; shared owns only the identifiers.
export const DATE_FORMATS = ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'DD MMM YYYY'] as const;
export const TIME_FORMATS = ['24h', '12h'] as const;

export const DateFormatSchema = z.enum(DATE_FORMATS);
export const TimeFormatSchema = z.enum(TIME_FORMATS);
export type DateFormat = z.infer<typeof DateFormatSchema>;
export type TimeFormat = z.infer<typeof TimeFormatSchema>;

// Write-side validation only: a stored zone missing from a future ICU list must
// not brick reads, so MeSchema keeps timezone as a plain nullable string.
export const TimeZoneSchema = z
  .string()
  .refine((tz) => Intl.supportedValuesOf('timeZone').includes(tz), 'Invalid timezone');
